module.exports = __webpack_public_path__ + "static/media/kc_marsh.b114ec82.jpg";